import { tProvidersProps } from '../../../../../../providers/LayoutProvider/Layout.types';
import { ProgrammedMessageActionContext } from './ProgrammedMessageAction.context';
import useProgrammedMessageAction from './ProgrammedMessageAction.hook';

export default function ProgrammedMessageActionProvider(
  props: tProvidersProps,
) {
  const { children } = props;
  const programmedMessageAction = useProgrammedMessageAction();

  return (
    <ProgrammedMessageActionContext.Provider value={programmedMessageAction}>
      {children}
    </ProgrammedMessageActionContext.Provider>
  );
}
